import Router from "@/routing";

export default class Instagram {

    scrapeAndVerifyAccount(username, verifyToken, callback)
    {
        this.sendInstagramRequest(username,function () {

            if(this.status !== 200 || !this.response.data) {
                callback(false);
                return;
            }

            if(!this.response.data.hashtags.includes(verifyToken))
            {
                callback(false);
                return;
            }

            callback(this.response.data);
        });
    }

    scrapeAccount(username, callback)
    {
        this.sendInstagramRequest(username,function () {

            if(this.status !== 200 || !this.response.data) {
                callback(false);
                return;
            }

            callback(this.response.data);
        });
    }

    sendInstagramRequest(username, callback)
    {
        let oReq = new XMLHttpRequest();

        oReq.responseType = 'json';

        oReq.addEventListener("load", callback, false);

        oReq.addEventListener("error", function () { callback(false); }, false);
        oReq.addEventListener("abort", function () { callback(false); }, false);

        oReq.open('GET', Router.generate('instagram_scraper', {instagramNickname: username}), true);
        oReq.send();
    }
}
